'use client';

import { Container } from '@/components/container';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/store';
import { CheckIcon, Lightbulb, Search, Users } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';

export const DiscoverBanner = () => {
  const { user } = useAuthStore();

  return (
    <div className="bg-white">
      <Container>
        <div className="flex flex-col lg:flex-row items-center gap-20 justify-between py-20">
          <div className="flex flex-col gap-4 flex-1 max-w-[730px]">
            <h1 className="text-xl md:text-3xl xl:text-[40px]  font-bold">
              Explore What's Possible!
            </h1>
            <p className="text-[18px] tracking-tighter text-[#24292E]">
              Innovation and change happen when people connect. At
              InnovationHUBSolutions , we bring together individuals across
              industries to exchange real-world experiences, tackle workplace
              challenges, and drive transformation. Discover powerful insights,
              proven strategies, and a collaborative community that turns ideas
              into action.
            </p>
            {/* {!user && (
              <Link
                className={cn(
                  buttonVariants({
                    variant: 'default',
                  }),
                  'w-fit font-bold uppercase'
                )}
                href="/sign-up"
              >
                Register Now
              </Link>
            )} */}
          </div>

          <div>
            <Image
              src="/discover-bg.svg"
              alt="hero-banner"
              width={240}
              height={320}
            />
          </div>
        </div>

        <div className="my-12">
          <div className="flex flex-col lg:flex-row gap-10 w-full justify-between items-stretch">
            {/* Value Points */}
            <div className="flex flex-col gap-8 flex-1 max-w-[600px]">
              {/* Point 1 */}
              <div className="flex items-start gap-4">
                <span className="bg-blue-100 rounded-full p-2 mt-1">
                  <CheckIcon className="text-blue-500 w-6 h-6" />
                </span>
                <div>
                  <div className="font-bold text-lg md:text-xl">
                    Democratize knowledge across industries
                  </div>
                  <div className="text-gray-700">
                    Breaking down silos to ensure valuable insights are
                    accessible to all.
                  </div>
                </div>
              </div>
              {/* Point 2 */}
              <div className="flex items-start gap-4">
                <span className="bg-blue-100 rounded-full p-2 mt-1">
                  <CheckIcon className="text-blue-500 w-6 h-6" />
                </span>
                <div>
                  <div className="font-bold text-lg md:text-xl">
                    Make real-world expertise accessible
                  </div>
                  <div className="text-gray-700">
                    Providing practical knowledge that can be immediately
                    applied to real challenges.
                  </div>
                </div>
              </div>
              {/* Point 3 */}
              <div className="flex items-start gap-4">
                <span className="bg-blue-100 rounded-full p-2 mt-1">
                  <CheckIcon className="text-blue-500 w-6 h-6" />
                </span>
                <div>
                  <div className="font-bold text-lg md:text-xl">
                    Encourage conversation and innovation
                  </div>
                  <div className="text-gray-700">
                    Creating spaces for meaningful dialogue that sparks new
                    ideas and approaches.
                  </div>
                </div>
              </div>
            </div>
            {/* Mission Statement */}
            <div className="flex-1  bg-blue-50 rounded-xl p-8 shadow-sm flex flex-col justify-center max-w-xl gradient-border">
              <div className="font-bold text-2xl mb-4">Mission Statement</div>
              <div className="text-lg text-blue-900 leading-relaxed">
                "IHQX is a collaborative platform where individuals from various
                industries and job roles connect to share practical insights,
                exchange knowledge, and foster innovation. We believe that by
                creating a space where expertise flows freely between sectors,
                we can accelerate progress and drive meaningful change across
                all industries."
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* Explore Our Key Features Section */}
      {/* <div className="bg-[#eaf3fb] py-16">
        <Container>
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
            Explore Our Key Features
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">

            <div className="bg-white rounded-xl justify-between p-6 flex col-span-3 row-span-1">
              <div className="flex flex-col justify-between gap-8 mb-2">
                <span className="bg-blue-100 p-2 w-fit rounded-full">
                  <Users className="w-4 h-4 text-ihs-blue" />
                </span>
                <div>
                  <span className="font-bold text-lg">
                    Crowdsourced Knowledge
                  </span>
                  <p className="text-sm text-gray-700 max-w-[300px]">
                    Access insights from professionals across industries and
                    roles.
                  </p>
                </div>
              </div>

              <div className="flex justify-end mt-2">
                <Image
                  src="/key-features.svg"
                  alt="key features"
                  width={260}
                  height={150}
                />
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 flex  gap-2 shadow-sm row-span-1">
              <div className="flex flex-col justify-between gap-8 mb-2">
                <span className="bg-blue-100 w-fit p-2 rounded-full">
                  <Image
                    src="/question-blue.svg"
                    alt="Q&A Tools"
                    width={16}
                    height={16}
                  />
                </span>
                <div>
                  <span className="font-bold text-lg">Q&A Tools</span>
                  <p className="text-sm text-gray-700 max-w-[300px]">
                    Access insights from professionals across industries and
                    roles.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl p-6 flex  gap-2 shadow-sm row-span-1">
              <div className="flex flex-col justify-between gap-8 mb-2">
                <span className="bg-blue-100 w-fit p-2 rounded-full">
                  <Lightbulb className="w-4 h-4 text-ihs-blue" />
                </span>
                <div>
                  <span className="font-bold text-lg">
                    "Idea Starter" Question
                  </span>
                  <p className="text-sm text-gray-700 max-w-[300px]">
                    Discover structured prompts that spark creative solutions.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl justify-between p-6 flex col-span-3 row-span-1">
              <div className="flex flex-col justify-between gap-8 mb-2">
                <span className="bg-blue-100 p-2 w-fit rounded-full">
                  <Search className="w-4 h-4 text-ihs-blue" />
                </span>
                <div>
                  <span className="font-bold text-lg">
                    Search Functionality
                  </span>
                  <p className="text-sm text-gray-700">
                    Easily find targeted insights, stories, and best practices.
                  </p>
                </div>
              </div>

              <div className="flex justify-end mt-2">
                <Image
                  src="/search-functionality.svg"
                  alt="key features"
                  width={260}
                  height={150}
                />
              </div>
            </div>
          </div>
        </Container>
      </div> */}

      {/* Member Benefits Section */}
      <div className="bg-white py-16">
        <Container>
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
            Member Benefits
          </h2>
          <div className="grid md:grid-cols-3 gap-6 mb-12 border border-2 rounded-2xl">
            <div className="rounded-xl p-6 bg-white">
              <div className="font-bold text-lg mb-2">
                Access Real-World Expertise
              </div>
              <div className="text-gray-700 text-sm">
                Learn from professionals with firsthand experience in workplace
                innovation and change management.
              </div>
            </div>
            <div className="rounded-xl p-6 bg-white">
              <div className="font-bold text-lg mb-2">
                Ask Questions & Get Answers
              </div>
              <div className="text-gray-700 text-sm">
                Engage in meaningful discussions with experts and peers.
              </div>
            </div>
            <div className="rounded-xl p-6 bg-white">
              <div className="font-bold text-lg mb-2">
                Collaborate Across Industries
              </div>
              <div className="text-gray-700 text-sm">
                Gain fresh perspectives by interacting with professionals from
                diverse fields.
              </div>
            </div>
            <div className="rounded-xl p-6 bg-white">
              <div className="font-bold text-lg mb-2">Stay Ahead of Trends</div>
              <div className="text-gray-700 text-sm">
                Keep up with emerging insights in innovation and change
                management.
              </div>
            </div>
            <div className="rounded-xl p-6 bg-white">
              <div className="font-bold text-lg mb-2">
                Solve Challenges Faster
              </div>
              <div className="text-gray-700 text-sm">
                Receive experience-based advice to navigate workplace obstacles
                effectively.
              </div>
            </div>
            <div className="rounded-xl p-6 bg-white">
              <div className="font-bold text-lg mb-2">
                Contribute & Be Recognized
              </div>
              <div className="text-gray-700 text-sm">
                Share your knowledge, establish your credibility, and enhance
                your professional reputation.
              </div>
            </div>
          </div>
          <div className="bg-[#eaf3fb] rounded-2xl p-10 flex flex-col items-center text-center">
            <h3 className="text-2xl font-bold mb-2">Ready to Explore More?</h3>
            <p className="text-gray-700 mb-6 max-w-2xl">
              Join a dynamic community where knowledge flows both ways,
              connecting professionals across industries to share insights and
              drive innovation forward.
            </p>

            {!user && (
              <Link
                className={cn(
                  buttonVariants({
                    variant: 'default',
                  }),
                  'w-fit font-bold uppercase'
                )}
                href="/sign-up"
              >
                Create an account
              </Link>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};
